<section id="skills" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="skills-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="skills-heading">{{ 'skillTable.title' | reportT }}</h2>
      <p class="section__desc">{{ 'skillTable.subtitle' | reportT }}</p>
    </div>
  </div>

  <article class="card card--clip" data-print-block>
    <!-- Commandes d'écran ; le papier reçoit le tableau lui-même. -->
    <div class="table-toolbar no-print">
      <div class="table-toolbar__field table-toolbar__field--search">
        <span class="table-toolbar__icon"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg></span>
        <input type="search" class="table-toolbar__input" data-skill-search
               autocomplete="off"
               [placeholder]="'skillTable.searchPlaceholder' | reportT"
               [attr.aria-label]="'skillTable.searchLabel' | reportT"
               [value]="query()"
               (input)="onSearch($event)">
      </div>
      <!-- Les options sont les compétences de la matière : la maquette en
           alignait vingt-six en dur, c'est une donnée. La valeur reste le code
           du référentiel, stable d'une langue à l'autre ; seul l'intitulé
           change. -->
      <select class="table-toolbar__select" data-skill-filter
              [attr.aria-label]="'skillTable.filterLabel' | reportT"
              (change)="onFilter($event)">
        <option value="">{{ 'skillTable.allCompetencies' | reportT }}</option>
        @for (competency of subject().competencies; track competency.competencyId) {
          <option [value]="competency.code" dir="auto">{{ competency.shortCode }}</option>
        }
      </select>
      <p class="table-toolbar__count" data-skill-count>{{ 'skillTable.showing' | reportT: countVars() }}</p>
    </div>

    <div class="table-wrap">
      <table class="data-table data-table--skills" data-skill-table>
        <caption class="sr-only">{{ 'skillTable.caption' | reportT }}</caption>
        <thead>
          <tr>
            <th class="col-code" [attr.aria-sort]="ariaSort('code')">
              <button type="button" class="sort-btn" data-sort="code"
                      [class.is-active]="sortKey() === 'code'"
                      [title]="'skillTable.sortBy' | reportT: sortCodeVars"
                      [attr.aria-label]="'skillTable.sortBy' | reportT: sortCodeVars"
                      (click)="toggleSort('code')"><span>{{ 'skillTable.code' | reportT }}</span><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m21 16-4 4-4-4"/><path d="M17 20V4"/><path d="m3 8 4-4 4 4"/><path d="M7 4v16"/></svg></button><span class="th-label-print" aria-hidden="true">{{ 'skillTable.code' | reportT }}</span>
            </th>
            <th>{{ 'skillTable.skill' | reportT }}</th>
            <th class="col-status data-table__end" [attr.aria-sort]="ariaSort('status')">
              <button type="button" class="sort-btn" data-sort="status"
                      [class.is-active]="sortKey() === 'status'"
                      [title]="'skillTable.sortBy' | reportT: sortStatusVars"
                      [attr.aria-label]="'skillTable.sortBy' | reportT: sortStatusVars"
                      (click)="toggleSort('status')"><span>{{ 'skillTable.status' | reportT }}</span><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m21 16-4 4-4-4"/><path d="M17 20V4"/><path d="m3 8 4-4 4 4"/><path d="M7 4v16"/></svg></button><span class="th-label-print" aria-hidden="true">{{ 'skillTable.status' | reportT }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.competencyId) {
            <tr [attr.data-code]="row.code" [attr.data-acquired]="row.acquired ? '1' : '0'">
              <!-- `dir="auto"` : `م12` est un mot arabe suivi d'un nombre, `c12`
                   non — sans cet indice l'algorithme bidi rend « 12م ». -->
              <td><span class="code-chip" dir="auto">{{ row.shortCode }}</span></td>
              <!-- Le descripteur seul. Le libellé du référentiel le doublait
                   sans rien apprendre au lecteur : « Identify family context »
                   au-dessus de « the ability to understand a short description
                   in context » disait deux fois la même chose, la première en
                   langue d'auteur de programme. -->
              <td class="data-table__skill">
                <span class="data-table__skill-name">{{ row.skillDescriptor }}</span>
              </td>
              <td class="data-table__end">
                <span [class]="row.badgeClass">@switch (row.outcome) {
                  @case ('Acquired') { <svg class="icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg> }
                  @case ('NotAcquired') { <svg class="icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg> }
                  @default { <svg class="icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M10.1 2.182a10 10 0 0 1 3.8 0"/><path d="M13.9 21.818a10 10 0 0 1-3.8 0"/><path d="M17.609 3.721a10 10 0 0 1 2.69 2.7"/><path d="M2.182 13.9a10 10 0 0 1 0-3.8"/><path d="M20.279 17.609a10 10 0 0 1-2.7 2.69"/><path d="M21.818 10.1a10 10 0 0 1 0 3.8"/><path d="M3.721 6.391a10 10 0 0 1 2.7-2.69"/><path d="M6.391 20.279a10 10 0 0 1-2.69-2.7"/></svg> }
                }<span>{{ row.statusLabel }}</span></span>
              </td>
            </tr>
          }
          <!-- Rien ne correspond : la ligne d'état vide prend toute la largeur
               plutôt que de laisser un `<tbody>` creux, qui se lirait comme un
               tableau cassé. -->
          @if (rows().length === 0) {
            <tr data-skill-empty>
              <td class="data-table__empty" colspan="3">{{ 'skillTable.noResults' | reportT }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </article>
</section>
